// extracted by mini-css-extract-plugin
module.exports = {"scroll_top":"scroll_top--oIWiX","scrollIcon":"scrollIcon--1LZST"};